import React, { useState } from 'react';
import { 
  Container, Typography, TextField, Button, Box, 
  Card, CardContent, Grid, Alert,
  CircularProgress
} from '@mui/material';
import apiClient from '../api/apiClient';
import LockResetIcon from '@mui/icons-material/LockReset';

export default function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    
    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('All fields are required');
      return;
    }
    
    if (newPassword !== confirmPassword) {
      setError('New passwords do not match');
      return;
    }
    
    if (newPassword.length < 4) {
      setError('New password must be at least 4 characters long');
      return;
    }
    
    setIsLoading(true);
    
    try {
      await apiClient.put('/users/change-password', { 
          current_password: currentPassword, 
          new_password: newPassword 
      });
      setSuccess('Password changed successfully!');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
        console.error("Failed to change password:", err);
        if (err.response && err.response.data) {
            const problem = err.response.data;
            setError(problem.detail || problem.title || 'Failed to change password. Check current password.');
        } else {
            setError('Failed to change password. Check current password.');
        }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="page-container">
      <Container maxWidth="sm">
        <Box sx={{ mb: 4, mt: 4 }}>
          <Typography variant="h5" sx={{ fontWeight: 600, color: '#1565c0', textAlign: 'center' }}>
            Change Your Password
          </Typography>
        </Box>
        
        <Card className="card form-container">
          <CardContent sx={{ p: 3 }}>
            <Box component="form" onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                {error && (
                  <Grid item xs={12}>
                    <Alert severity="error" sx={{ mb: 1 }}>{error}</Alert>
                  </Grid>
                )}
                
                {success && (
                  <Grid item xs={12}>
                    <Alert severity="success" sx={{ mb: 1 }}>{success}</Alert>
                  </Grid>
                )}
                
                <Grid item xs={12}>
                  <TextField
                    label="Current Password"
                    type="password"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    fullWidth
                    required
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                
                <Grid item xs={12}>
                  <TextField
                    label="New Password"
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    fullWidth
                    required
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                
                <Grid item xs={12}>
                  <TextField
                    label="Confirm New Password"
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    fullWidth
                    required
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                
                <Grid item xs={12} sx={{ mt: 1 }}>
                  <Button 
                    type="submit" 
                    variant="contained" 
                    fullWidth
                    disabled={isLoading}
                    startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <LockResetIcon />}
                    className="action-button"
                    sx={{ 
                      bgcolor: '#1565c0',
                      '&:hover': { bgcolor: '#0d47a1' },
                      py: 1.2
                    }}
                  >
                    {isLoading ? 'Updating...' : 'Update Password'}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </div>
  );
} 